import { NavLink, type NavLinkProps } from 'react-router-dom';

import { type Theme, css } from '@emotion/react';
import styled from '@emotion/styled';

import { Layout, LayoutProps } from 'antd';

export const Sidebar = styled(Layout.Sider)<LayoutProps>`
  &.ui-layout-sider {
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .ui-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const Menu = styled.nav`
  display: flex;
  flex-direction: column;
`;

// Shared so that an item leaving this app (Pulse, which is a portal of its own) sits in the same
// column as the routed ones. `.active` never matches on the anchor, which is right: the browser is
// on another origin by then.
const menuItemStyles = (theme: Theme) => css`
  height: 82px;
  color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 600;
  font-size: 12px;
  /* A label longer than the 105px sidebar wraps; centred, both lines sit under the icon. */
  text-align: center;

  &:hover {
    color: ${theme.colors.white};
    background-color: ${theme.colors.bgDarkActive};
  }

  &.active {
    background-color: ${theme.colors.bgDarkActive};
    color: ${theme.colors.bgYellow};
  }
`;

export const MenuLink = styled(NavLink)<NavLinkProps>`
  ${({ theme }) => menuItemStyles(theme)};
`;

export const MenuExternalLink = styled.a`
  ${({ theme }) => menuItemStyles(theme)};
`;
